$(function(){
    $('#user-auto-complete').select2({
        placeholder: 'Enter User Name',
        minimumInputLength: 2,
        allowClear: true,
        theme: 'bootstrap4',
        ajax: {
            url: BASE_URL+'core/ajax/getuserautocomplete',
            dataType: 'json',
            delay: 250,
            data: function (data) {
                return {
                    kwdAutoComplete: data.term
                };
            },
            processResults: function (response) {
                return {
                    results:response
                };
            },
            cache: true
        }
    })
    $("#user-auto-complete").change(function(){
        var val  = $(this).val();
        var text = $(this).find("option:selected").text();
        if(val != '' && typeof val != 'undefined')
        {
            $("#copy_identity_user").text(text);
            $("#identitycopy-btn").show();
        }
        else {
            $("#identitycopy-btn").hide();
        }

    })


    /* Mail Actions */
    $(".mail-queue-form-actions").click(function(event){
        event.preventDefault();
        var clickedType	= $(this).data('type');
        if(clickedType == 'resendSelected' || clickedType == 'deleteSelected')
        {
            if(!$('#handleMailQueue input[name="selectMailQueueRow[]"]:checked').length)
            {
                alert('Please select any one of the record');
                return false;
            }
        } else if(clickedType == 'resendAll' || clickedType == 'deleteAll')
        {
            $('.selectMailQueueRow, #selectAllMailQueueRow').attr('checked', true);
        }
        var confirmMessage	= $(this).data('confirm-message');
        $('#actionType').val(clickedType);
        if(confirm(confirmMessage))
        {
            $('#handleMailQueue').submit();
        } else
        {
            if(clickedType == 'resendAll' || clickedType == 'deleteAll')
            {
                $('.selectMailQueueRow, #selectAllMailQueueRow').attr('checked', false);
            }
        }
        return true;
    });
    $("#selectAllMailQueueRow").click(function(){
        if($(this).is(":checked"))
        {
            $('.selectMailQueueRow').attr('checked', true);
        } else
        {
            $('.selectMailQueueRow').attr('checked', false);
        }
    });

    $(document).on("click",".view-mail-log-tab li a", function (e) {
        $(this).tab('show');
    })

    $("input[name='user_approval_status'],input[name='account_switch_status']").on('change',function(){
        var selectedVal = $(this).val();
        $(".statusValueType").not('#'+selectedVal+'statusValue').slideUp('fast');
        $('#commentBox').slideDown('fast');
        $('#'+selectedVal+'statusValue').slideDown('fast');
        if(selectedVal =='approved')
        {
            $("#reviewStatusHeader").html("Approval");
            $("#reviewStatus").html("Approve");
            $("textarea[name='comment']").val("");
            $(".notifyViaEmail").slideUp('fast');
            $(".application-access").slideDown('fast');
        }
        else
        {
            $("#reviewStatusHeader").html("Reject");
            $("#reviewStatus").html("Reject");
            $("textarea[name='comment']").val("");
            $(".notifyViaEmail").slideDown('fast');
            $(".application-access").slideUp('fast');
        }
    })

    $(".user-approval-form-wrapper input[name='portfolio']").on('change',function(){
        var portfolio = $(this).val();
        if(portfolio == 'transport')
        {
            var customerArray = transportCustomerArray;
            $("#section-master-customer").removeClass('col-md-5').addClass('col-md-10');
            $("#section-end-customer").hide();
            $(".deny-end-customer-access").show();
        }
        else
        {
            var customerArray = accessCustomerArray;
            $("#section-end-customer").show();
            $("#section-master-customer").removeClass('col-md-10').addClass('col-md-5');
        }
        var mainCustomerObj     = $("#main_customer");
        var relatedCustomerObj  = $("#related_customers");
        mainCustomerObj.find('option:not(:first)').remove();
        relatedCustomerObj.find('option').remove();
        $.each(customerArray, function(key, data){
            mainCustomerObj.append($("<option></option>").text(data.value).val(data.id));
            relatedCustomerObj.append($("<option></option>").text(data.value).val(data.id));
        });

        mainCustomerObj.trigger('change');
        relatedCustomerObj.trigger('change');
    })
    $(".user-approval-form-wrapper #main_customer, .user-customer-form-wrapper #access_main_customer").on('change',function(){
        var mainCustomer = $(this).val();
        getEndCustomer(mainCustomer);
    })
    $(".user-approval-form-wrapper #end_customers").on('change',function(){
        if($(this).val() != '') {
            $(".deny-end-customer-access").each(function(){
                $(this).find("input[type='checkbox']:checked").prop('checked',false);
            })
            $(".deny-end-customer-access").hide();

        } else {
            $(".deny-end-customer-access").show();
        }
    })

    $(document).on('click', 'a.dashboard-bubble-link', function (e){
        e.preventDefault();
        $(this).parents('form').trigger('submit');
    });

    /* Notification Actions starts*/

    $(".notification-form-actions").click(function(event){
        event.preventDefault();
        var clickedType	= $(this).data('type');
        if(clickedType == 'deleteSelected')
        {
            if(!$('#clearNotification input[name="selectNotificationRow[]"]:checked').length)
            {
                alert('Please select any one of the record');
                return false;
            }
        } else if(clickedType == 'deleteAll')
        {
            $('.selectNotificationRow, #selectAllNotificationRow').prop('checked', true);
        }
        var confirmMessage	= $(this).data('confirm-message');
        $('#actionType').val(clickedType);
        if(confirm(confirmMessage))
        {
            $('#clearNotification').submit();
        } else
        {
            if(clickedType == 'deleteAll')
            {
                $('.selectNotificationRow, #selectAllNotificationRow').prop('checked', false);
            }
        }
        return true;
    });
    $("#selectAllNotificationRow").click(function(){
        if($(this).is(":checked"))
        {
            $('.selectNotificationRow').prop('checked', true);
        } else
        {
            $('.selectNotificationRow').prop('checked', false);
        }
    });
    /* Notification Actions ends*/

    $('select[name=user_type_id]').on('change', function() {
        $(".main-customer").removeClass('required');
        if($(this).val() == 2)
        {
            $(".main-customer").addClass('required');
        }
    });

    if($('select[name=user_type_id]').length > 0)
    {
        if($('select[name=user_type_id] option:selected').val() == 2)
        {
            $(".main-customer").addClass('required');
        }
    }

    //display tab based on the Id passed in the URL
    if($('.user-profile').length > 0)
    {
        var url         = window.location.href;
        if(url.indexOf("/user/profile/view/settings/") > 0)
        {
            $(".tab-pane").removeClass("show active");
            $(".nav-link").removeClass('active');
            $('a[href^="#tabs-settings"]').addClass('active')
            $("#tabs-settings").addClass("show active");
        }
        else if(url.indexOf("emailnotifications") > 0)
        {
            $(".tab-pane").removeClass("show active");
            $(".nav-link").removeClass('active');
            $('a[href^="#email-notifications"]').addClass('active')
            $("#email-notifications").addClass("show active");
        }
    }

    //---------------------------------------------------------------------------------------------------------------------------------
    $('.popover-wrapper').popover({
        trigger: 'focus click hover',
        html: true
    });

    $(document).on('click','.close-per-phover',function(){
        $('.popover-wrapper').popover('hide');
    })

    var endDateObj              = new Date();
    endDateObj.setFullYear(new Date().getFullYear()+1);
    endDateObj.setMonth(11,31);
    $(".scheduler-date-time-picker").datetimepicker({
        format: 'yyyy-mm-dd hh:ii',
        autoclose: true,
        minuteStep: 2,
        startDate: new Date().toISOString().slice(0, 10).toString() + ' 00:00:00',
        endDate: endDateObj
    });

    $('.date-picker').datetimepicker({
        format: 'yyyy-mm-dd',
        weekStart: 1,
        todayBtn:  1,
		autoclose: 1,
		todayHighlight: 1,
		startView: 2,
        minView: 2,
        endDate: new Date().toISOString().slice(0, 10).toString() + ' 00:00:00',
        forceParse: 0

    });

    $('.date-picker').datetimepicker({
        format: 'yyyy-mm-dd',
        weekStart: 1,
        todayBtn:  1,
		autoclose: 1,
		todayHighlight: 1,
		startView: 2,
        minView: 2,
        endDate: new Date().toISOString().slice(0, 10).toString() + ' 00:00:00',
        forceParse: 0

    });

    if($('.schedule-job-type').length > 0)
    {
        displayJobType();
    }
    $('.schedule-job-type').on('change', function (){
        displayJobType();
    });
    if($('input[name=schedule_recurrence]').length > 0)
    {
        displayScheduleRecurrence();
    }
    $('input[name=schedule_recurrence]').on('change', function (){
        displayScheduleRecurrence();
    });
    if($('.description-chars-left').length > 0)
    {
        displayCharLimit();
    }
    $('textarea[name=description], .chars-limited-input').on('keyup change focus blur', function (){
        displayCharLimit();
    });
    $('.user-password').PassRequirements({
        rules: {
            minlength: {
                text: "Be at least minLength characters long",
                minLength: 12,
            },
        }
    });

    $("#registrationForm .application-level1").on("click",function(){
        var index = $(this).data("index");
        $(".application-level2-box").hide();
        $(".application-level2-box-"+index).show();
        $("#registration_end_customer").hide();
        if (index == 'accessSupport') {
            $("#registration_end_customer").show();
        }

    })

    $("#registrationForm input[name='is_endcustomer'], #switchCustomerPortfolio input[name='is_endcustomer']").on("click",function(){
       if ($(this).val() == 'yes') {
         $(".registration_end_customer_yes_select").show();
       } else {
            $(".registration_end_customer_yes_select").hide();
       }
    })


    function getEndCustomer(masterCustomerId)
    {
        var endCustomerObj  = $("#end_customers");
        endCustomerObj.find('option:not(:first)').remove();
        if(masterCustomerId !='')
        {
            $.ajax({
                dataType: "json",
                url:  BASE_URL+'core/ajax/getendcustomer',
                data: {masterCustomerId:masterCustomerId},
                success: function(jsonResult) {
                    $.each(jsonResult, function(key, cInfo){
                        endCustomerObj.append($("<option></option>").text(cInfo.value).val(cInfo.id));
                    });
                }
            });
        }
        endCustomerObj.trigger('change');
    }

    function displayJobType()
    {
       var selectedValue       = $('.schedule-job-type :selected').val();
        if(selectedValue == 'jobScript')
        {
            $('#schedulePath').removeClass('d-none');
            $('#scheduleCommand').addClass('d-none');
        }
        else if(selectedValue == 'linuxCommand')
        {
            $('#schedulePath').addClass('d-none');
            $('#scheduleCommand').removeClass('d-none');
        }
        else
        {
            $('#schedulePath').addClass('d-none');
            $('#scheduleCommand').addClass('d-none');
        }
    }
    function displayScheduleRecurrence()
    {
        let selectedValue       = $('input[name=schedule_recurrence]:checked').val();
        if(selectedValue == 'once')
        {
            $('#scheduleRunOn').removeClass('d-none');
            $('#scheduleCrontab').addClass('d-none');
        }
        else if(selectedValue == 'recurring')
        {
            $('#scheduleRunOn').addClass('d-none');
            $('#scheduleCrontab').removeClass('d-none');
        }
    }
    function displayCharLimit()
    {
        var enteredDesc         = '';
        var maxAllowedChars     = 500;
        if($('textarea[name=description]').length > 0)
        {
            enteredDesc     = $('textarea[name=description]').val();
            maxAllowedChars = $('textarea[name=description]').attr('maxlength');
        }
        else if($('.chars-limited-input').length > 0)
        {
            enteredDesc     = $('.chars-limited-input').val();
            maxAllowedChars = $('.chars-limited-input').attr('maxlength');
        }
        $(".description-chars-left").text(maxAllowedChars-enteredDesc.length);
    }

    $(".apikey-form-wrapper #apiTypeId").on('change',function(){
        var apiTypeId = $(this).val();
        getEntity(apiTypeId);
    })


        function getEntity(apiTypeId)
        {
            var entityObj  = $("#entityId");
            entityObj.find('option:not(:first)').remove();
            if(apiTypeId !='')
            {
                $(".customer").show();
                $.ajax({
                    dataType: "json",
                    url:  BASE_URL+'core/ajax/getentity',
                    data: {apiTypeId:apiTypeId},
                    timeout: 60000,
                    beforeSend: function() {
                        $("#customerIdProgress").removeClass('d-none');
                        $("#customer").hide();
                    },
                    success: function(jsonResult) {
                        //Clear existing option
                        entityObj.empty();

                        //Append Select option to the generate api key entity field
                        entityObj.append('<option value="">Select</option>');
                        $.each(jsonResult, function(key, entityInfo){
                            entityObj.append($("<option></option>").text(entityInfo.name).val(entityInfo.id));
                        });
                        $("#customerIdProgress").addClass('d-none');
                        $("#customer").show();
                    }
                });
            }else
            {
                $(".customer").hide();
            }
            // Trigger change event to update select 2
           entityObj.trigger('change');
        }


        $("#internalUserForm select[name='user_type_id']").on('change',function(){
            var selectedVal = $(this).val();
            $(".portfolio").slideUp('fast');
            if(selectedVal =='2')
            {
                $(".portfolio").slideDown('fast');
            }
        })
    })
